import { statusTypes } from '../config/constants';
import genericValidationMethods, { getValidationState } from './genericValidation';

export function OtherValidation() {
  this.rules = {
    teasLocation: {
      validationMethod: 'getStringValidationState',
      errorMsg: 'Missing TEAS Location',
      id: 'location',
      path: ['teas']
    },
    teasDate: {
      validationMethod: 'getDateValidationState',
      errorMsg: 'Missing TEAS Date',
      id: 'date',
      path: ['teas']
    },
    teasScore: {
      validationMethod: 'getNumericValidationState',
      errorMsg: 'Missing TEAS Score',
      id: 'score',
      path: ['teas']
    },
    foreignLanguage: {
      validationMethod: 'getForeignLanguageValidationState',
      errorMsg: 'Missing Foreign Language Information',
      id: 'foreignLanguage'
    }
  };
  // if other is true, otherLanguage must have data
  this.getForeignLanguageValidationState = function(foreignLanguage) {
    return !foreignLanguage.other ? statusTypes.SUCCESS :
        this.getStringValidationState(foreignLanguage.otherLanguage);
  };
  this.getStringValidationState = genericValidationMethods.getStringValidationState;
  this.getDateValidationState = genericValidationMethods.getDateValidationState;
  this.getNumericValidationState = genericValidationMethods.getNumericValidationState;
  this.getValidationStatus = getValidationState.bind(this);
}

export default OtherValidation;